import { useApi } from './useApi';
import { apiService } from '../services/api';

interface UspItem {
  title: string;
  description: string;
  icon: 'SafeIcon' | 'CaduceusIcon' | 'InjectionIcon';
}

interface UspSectionData {
  id: number;
  documentId: string;
  title: string;
  description?: string;
  usp1?: UspItem;
  usp2?: UspItem;
  usp3?: UspItem;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

export function useUspSection() {
  return useApi<UspSectionData>(apiService.getUspSection);
}
